import { LitElement, html, TemplateResult, PropertyValues } from 'lit';
import { property, customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { IconSets } from '../../../../theme';
import { FontSize } from '../../../../ui/gzIconButton/types';
import { DEVICES_CLASS } from '../../../common/constants';
import { BaseWebComponentTranslator } from '../../../../framework/BaseWebComponentTranslator';
import { USERS_ICON_CLASS_MAP } from '../../../userBehaviorRisksApp/types';
import { WEB_COMPONENT_GZ_RM_ICON } from '../../../../webcomponents.constants';

/**
 * @summary Type here the description of this component
 * @tag gz-rm-icon
 */
@customElement(WEB_COMPONENT_GZ_RM_ICON)
export class GzRmIconWebComponent extends LitElement {
  /**
   * The type of the entity which we should display an icon for.
   */
  @property({ type: Object, attribute: true, reflect: true })
  type = 0;

  /**
   * Icon class map type. Decides which mapping for type -> icon name to use.
   */
  @property({ type: String, attribute: true, reflect: true })
  iconClassMapType = '';

  /**
   * Which icon set to use to render the icon. Undefined means the default one.
   */
  @property({ type: String, attribute: true, reflect: true })
  iconSet?: keyof typeof IconSets = undefined;

  @state()
  iconClassState: IconClassState = {
    mapping: new Map(),
    translateFn: () => '',
  };

  static get styles() {
    return styles;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    if (this.iconClassMapType) {
      const classMapStates = iconClassTypes[this.iconClassMapType];
      if (classMapStates) {
        this.iconClassState = classMapStates;
      }
    }
  }

  render(): TemplateResult {
    return html`
      <gz-tooltip .tooltipText="${this.iconClassState.translateFn(this.type)}">
        <gz-icon
          exportparts="highlightable"
          .customIconSet="${this.iconSet}"
          .name="${this.iconClassState.mapping.get(this.type)}"
          .size="${FontSize.ICON_SIZE_20}"
          color="var(--chart-302-icon-buttons-titles)"
        ></gz-icon>
      </gz-tooltip>
    `;
  }
}

interface IconClassState {
  mapping: Map<number, string>;
  translateFn: (type: number) => string;
}

type IconClassTypes = Record<string, IconClassState>;

const iconClassTypes: IconClassTypes = {
  devices: {
    mapping: DEVICES_CLASS,
    translateFn: BaseWebComponentTranslator.getInstance().getDeviceTypes,
  },
  users: {
    mapping: USERS_ICON_CLASS_MAP,
    translateFn: BaseWebComponentTranslator.getInstance().getRiskManagementUserType,
  }
};

declare global {
  interface HTMLElementTagNameMap {
    'gz-rm-icon': GzRmIconWebComponent;
  }
}
